import { PATIENT } from "../constants";

const initialState = {
  patients: [],
  patient: null,
  isLoadingPatients: false,
  isLoadingPatient: false,
  error: null,
};

const patientReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case PATIENT.PATIENT_GET_ALL:
      return {
        ...state,
        isLoadingPatients: true,
        error: null,
      };
    case PATIENT.PATIENT_GET_ALL_FAILURE:
      return {
        ...state,
        isLoadingPatients: false,
        error: action.payload,
      };
    case PATIENT.PATIENT_GET_ALL_SUCCESS:
      return {
        ...state,
        isLoadingPatients: false,
        patients: action.payload,
        error: null,
      };
    case PATIENT.PATIENT_CREATE:
      return {
        ...state,
        isLoadingPatient: true,
        error: null,
      };
    case PATIENT.PATIENT_CREATE_FAILURE:
      return {
        ...state,
        isLoadingPatient: false,
        error: action.payload,
      };
    case PATIENT.PATIENT_CREATE_SUCCESS:
      return {
        ...state,
        isLoadingPatient: false,
        patient: action.payload,
        patients: [
          ...state.patients.filter(
            (patient) => String(patient.id) !== String(action.payload.id),
          ),
          action.payload,
        ],
        error: null,
      };
    default:
      return state;
  }
};

export default patientReducer;
